import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Button, ButtonGroup, Checkbox, FormControlLabel } from '@mui/material'
import objectStore from '../../stores/objectStore'
import filterStore from '../../stores/filterStore'

import logger from '../../utils/logger'

const CategorySelector = observer(({ onSelectionChange }) => {
	const [activeCategoryId, setActiveCategoryId] = useState(null) // ID активной категории

	const handleCategoryClick = categoryId => {
		logger.log('🎈 Category Clicked:', categoryId)

		if (categoryId === null) {
			filterStore.setActiveCategoryId(null) // Сброс до "Все"
		} else {
			filterStore.setActiveCategoryId(categoryId)
		}
		logger.log('Active Category ID:', activeCategoryId)
		
		// Сбрасываем extraFilter при изменении категории
		filterStore.clearExtraFilter()
	}

	const handleSubcategoryChange = (subcategory, isChecked) => {
		filterStore.toggleSubcategory(subcategory)
		
		// Сбрасываем extraFilter при изменении подкатегории
		filterStore.clearExtraFilter()
	}

return (
	<div>
		{import.meta.env.VITE_SHOW_COMPONENT_NAME === 'true' && <div onClick={() => logger.log('CategorySelector Render')}>% CategorySelector object%</div>}

		<ButtonGroup variant='contained' className='mb-4'>
			<Button
				color={
					!filterStore.objectPageControls.activeCategoryId
						? 'primary'
						: 'default'
				}
				onClick={() => handleCategoryClick(null)}
				size='small'
				sx={{ textTransform: 'none' }}
			>
				Все
			</Button>
			{objectStore.categories.map(category => (
				<Button
					key={category.id}
					color={
						Number(filterStore.objectPageControls.activeCategoryId) ===
						Number(category.id)
							? 'primary'
							: 'default'
					}
					onClick={() => handleCategoryClick(category.id)}
					size='small'
					sx={{ textTransform: 'none' }}
				>
					{category.name}
				</Button>
			))}
		</ButtonGroup>

		{/* Рендеринг подкатегорий */}
		{filterStore.objectPageControls.activeCategoryId && (
			<div>
				{objectStore.categories
					.find(
						cat =>
							Number(cat.id) ===
							Number(filterStore.objectPageControls.activeCategoryId)
					)
					?.subcategories.map(subcategory => (
						<FormControlLabel
							key={subcategory.id}
							control={
								<Checkbox
									checked={filterStore.objectPageControls.selectedSubcategories.some(
										sub => sub.id === subcategory.id
									)}
									onChange={() => handleSubcategoryChange(subcategory)}
								/>
							}
							label={subcategory.name}
						/>
					))}
			</div>
		)}
	</div>
)
})

export default CategorySelector
